export default "__VITE_ASSET___Hbon1NL__"